document.addEventListener('DOMContentLoaded', () => {
  const menuBtn = document.getElementById('menu-btn');
  const navigation = document.getElementById('navigation');
  const htmlTag = document.documentElement;
  function toggleMenu() {
    const open = menuBtn.classList.toggle('is-open');
    menuBtn.setAttribute('aria-expanded', open);
    navigation.classList.toggle('is-open', open);
    navigation.setAttribute('aria-hidden', !open);
    htmlTag.classList.toggle('no-scroll', open);
  }

  if (menuBtn && navigation) {
    menuBtn.addEventListener('click', () => {
      toggleMenu();
    });
  }
  const anchorLinks = document.querySelectorAll('a.nav-anchor');
  anchorLinks.forEach(link => {
    link.addEventListener('click', (event) => {
      toggleMenu();
    });
  });

  const toggleBtns = document.querySelectorAll('.c-toggle');
  toggleBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const content = btn.closest('.c-interview');
      const isOpen = content.classList.toggle('is-open');
      const box = btn.closest('.c-interview__content');
      if (!isOpen) {
        const height = box ? box.offsetHeight : 0;
        window.scrollBy({ top: -height, behavior: 'smooth' });
      }
      box.setAttribute('aria-hidden', String(!isOpen));
      btn.setAttribute('aria-expanded', String(isOpen));
      btn.textContent = isOpen ? '閉じる' : '続きを読む';
    });

  });
  const footerTopBtn = document.getElementById('page-top-btn');
  if (footerTopBtn) {
    footerTopBtn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    // p-heroセクションの下部までスクロールしたらボタンを表示
    const heroSection = document.querySelector('.p-hero__wrapper');
    if (heroSection && 'IntersectionObserver' in window) {
      const heroObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const scrolledPastHero = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          footerTopBtn.classList.toggle('is-visible', scrolledPastHero);
        });
      }, { threshold: 0 });
      heroObserver.observe(heroSection);
    }

    // フッターが見えている間はbottom位置を持ち上げる
    const footer = document.querySelector('.p-footer');
    if (footer && 'IntersectionObserver' in window) {
      const footerObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          footerTopBtn.classList.toggle('is-above-footer', entry.isIntersecting);
        });
      }, { threshold: 0 });
      footerObserver.observe(footer);
    }
  }
  // scrollhints
  const scrollOptions = {
    applyToParents: true,
    i18n: {
      scrollable: '横スクロール<br>可能です'
    }
  }
  new ScrollHint('.p-about__product-image', scrollOptions);
  new ScrollHint('.p-work__portrait-content', scrollOptions);
  new ScrollHint('.p-career__opening-map-image', scrollOptions);
});
